import { LeafAlert } from "./alert.component.js";
customElements.define("leaf-alert", LeafAlert);
export {
  LeafAlert
};
//# sourceMappingURL=alert.js.map
